import './mail-accepting-actions.ajscss';

import { IAgentConfigDeprecatedService } from '@agent/core/agent/agent-config-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IQualificationDeprecatedService } from '@agent/core/contact/qualification-deprecated.service';
import { IComponentController, IComponentOptions, ILogService, IPromise } from 'angular';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './mail-accepting-actions.template.html';

class MailAcceptingActionsCtrl extends DisplayDeprecatedComponent implements IComponentController {
  responseId: string;
  bCanRefuse: boolean;

  constructor(
    private readonly $log: ILogService,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly agentConfigDeprecatedService: IAgentConfigDeprecatedService,
    private readonly qualificationDeprecatedService: IQualificationDeprecatedService
  ) {
    super();
  }

  $onInit(): void {
    this.contactDeprecatedService.getContact(this.responseId).then(
      contact => (this.bCanRefuse = this.agentConfigDeprecatedService.canRefuseContact(contact.channel)),
      err => this.$log.error(err)
    );
  }

  accept(): void {
    this.contactDeprecatedService.accept(this.responseId).catch(() => {
      this.$log.error('[MailAcceptingActions] accept() - Booking Not Found');
    });
  }

  refuse(): void {
    this.contactDeprecatedService.refuse(this.responseId, 'REFUSED_MAIL');
  }

  canRefuse(): boolean {
    return this.bCanRefuse;
  }

  finishQualification(responseId: string): IPromise<any> {
    return this.qualificationDeprecatedService.finishQualification(responseId);
  }

  renewPostTreatment(responseId: string): IPromise<any> {
    return this.qualificationDeprecatedService.renewPostTreatment(responseId);
  }
}

export class MailAcceptingActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = [
    '$log',
    'contactDeprecatedService',
    'agentConfigDeprecatedService',
    'qualificationDeprecatedService',
    MailAcceptingActionsCtrl,
  ];
}

export default 'contactMailAcceptingActions';
